// extracted by mini-css-extract-plugin
export default {"tooltip":"uO-z","arrow":"vO-z"};